import React from 'react'
import { Avatar, Skeleton, Typography, useGAEvent } from '..'
import { generateBGColorClassName } from '../../../utils/randomColor'
import { useNavigate } from 'react-router-dom'
import { customEvents } from '../../../utils/customEvents'
import { Tooltip } from 'flowbite-react'

export const UserSearch = ({ teamsData = [], loading = false, closeFilterMenu = () => null,
    saveSearchHistory = () => null }) => {
    return (<div className='p-3 flex flex-col gap-3'>
        <Typography variant="base" className="text-secondary-400 font-medium" text={`All Users (${teamsData?.length || 0})`} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 ">
            {loading ? [1, 2, 3, 4].map((item) => <Loader key={item} />) :
                !!teamsData?.length && teamsData?.map((team, index) => <SingleUser
                    saveSearchHistory={saveSearchHistory} key={team?._id}
                    closeFilterMenu={closeFilterMenu} index={index} {...team} />)}
        </div>
        {!loading && !teamsData?.length && <div className='flex justify-center h-[8vh] items-center w-full'>
            <Typography variant="sm" text="No Users Found" className="text-secondary-400" />
        </div>}
    </div>)
}

export const SingleUser = ({ index = -1,
    name = '',
    email = '', _id = null,
    closeFilterMenu = () => null,
    saveSearchHistory = () => null 
}) => {

    const navigate = useNavigate();
    const sendGAEvent = useGAEvent();

    const handleView = async () => {
        closeFilterMenu()
        sendGAEvent(customEvents.GA_VIEW_MEMBER);
        await saveSearchHistory({ type: "user", globalSearchLogId: _id })
        navigate(`/teams/details?id=${_id}&tab=assigned_clients`);

    }

    return (<div className='flex gap-3 items-center w-full my-1'>
        <span onClick={handleView}>
            <Avatar alt={name} className={`${generateBGColorClassName(index)} cursor-pointer`}
                type="text" />
        </span>
        <div className='flex flex-col gap-1 w-8/12'>
            <Tooltip placement="bottom" content={name}>
                <Typography variant="base" onClick={handleView}  
                    className="text-secondary-600 line-clamp-2 cursor-pointer hover:text-secondary-600" text={name} />
            </Tooltip>
            <Typography variant="sm" className="text-secondary-400 truncate " text={email} />
        </div>
    </div>)
}

const Loader = () => (
    <div className='flex gap-3 items-center w-full my-1'>
        <Skeleton parentClassName="w-fit" length={1} className="h-[2.7rem] w-[2.7rem] rounded-full" />
        <div className='w-full flex flex-col gap-2'>
            <Skeleton length={1} className="h-5 w-full rounded-md" />
            <Skeleton length={1} className="h-3 w-full rounded-md" />
        </div>
    </div>
)